import { useSelector } from 'react-redux';
import { convertToMarathiNumber } from '../components/marathiNumbers';
import { Link } from 'react-router-dom';

const Events = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const content = {
        English: {
            title: "Events",
            breadcrumb: {
                home: 'HOME',
                page: 'EVENTS'
            },
        },
        मराठी: {
            title: "कार्यक्रम",
            breadcrumb: {
                home: 'मुख्यपृष्ठ ',
                page: 'कार्यक्रम'
            },
        }
    };

    const t = content[selectedLang];

    const tableHeaders = {
        srNo: {
            English: "Sr. No.",
            मराठी: "अ.क्र.",
        },
        name: {
            English: "Monument Names",
            मराठी: "स्मारकाचे नाव",
        },
        anniversary: {
            English: `Birth Anniversary/ Death Anniversary`,
            मराठी: `जयंती/पुण्यतिथी `,
        },
        date: {
            English: `Date`,
            मराठी: `दिनांक`,
        }
    };

    const documents = [
        {
            id: 1,
            name: {
                English: "Savitribai Phule Birth Place, Ta. Khandala, Dist. Satara",
                मराठी: "सावित्रीबाई फुले जन्मस्थान, नायगाव, ता.खंडाळा, जि.सातारा",
            },
            anniversary: {
                English: "Savitribai Phule Birth Anniversary",
                मराठी: "सावित्रीबाई फुले जयंती",
            },
            date: {
                English: "3rd January",
                मराठी: "३ जानेवारी",
            },
        },
        {
            id: 2,
            name: {
                English: "Lakhujirao Jadhav Rajawada, Ta. Sindhkhedraja, Dist. Bhuldhana",
                मराठी: "लखूजीराव जाधव राजवाडा, सिंदखेडराजा, जि.बुलडाणा",
            },
            anniversary: {
                English: "Jijau Birth Anniversary",
                मराठी: "जिजाऊ, जन्मोत्सव सोहळा",
            },
            date: {
                English: "12th January",
                मराठी: "१२ जानेवारी",
            },
        },
        {
            id: 3,
            name: {
                English: "Late. Ram Ganesh Gadkari, Residence, Ta. Savner, Dist. Nagpur",
                मराठी: "कै.राम गणेश गडकरी, निवासस्थान, सावनेर, जि.नागपूर",
            },
            anniversary: {
                English: "Death Anniversary",
                मराठी: "पुण्यतिथी",
            },
            date: {
                English: "23rd January",
                मराठी: "२३ जानेवारी",
            },
        },
        {
            id: 4,
            name: {
                English: "Swatyantravir Savarkarwada, Bhagur, Dist. Nashik",
                मराठी: "स्वा.सावरकरवाडा, भगूर, जि.नाशिक",
            },
            anniversary: {
                English: "Death Anniversary",
                मराठी: "पुण्यतिथी",
            },
            date: {
                English: "26th February",
                मराठी: "२६ फेब्रुवारी",
            },
        },
        {
            id: 5,
            name: {
                English: "Malojiraje Bhosale Gadhi, Verul, Ta. Khulatabad, Dist. Chh. Sambhajinagar",
                मराठी: "मालोजीराजे भोसले गढी, वेरुळ, ता.खुलताबाद, जि.औरंगाबाद",
            },
            anniversary: {
                English: "Shahaji Raje Birth Anniversary",
                मराठी: "शहाजीराजे जयंती",
            },
            date: {
                English: "18th March",
                मराठी: "१८ मार्च",
            },
        },
        {
            id: 6,
            name: {
                English: "Hutatma Rajguru Birth Place, Rajguru Nagar, Ta. Khed, Dist. Pune",
                मराठी: "हुतात्मा राजगुरु जन्मस्थळ, राजगुरु नगर, ता.खेड, जि.पुणे",
            },
            anniversary: {
                English: "Death Anniversary",
                मराठी: "हुतात्मादिन",
            },
            date: {
                English: "23rd March",
                मराठी: "२३ मार्च",
            },
        },
        {
            id: 7,
            name: {
                English: "Mahatma Phule Wada, Pune",
                मराठी: "महात्मा फुले वाडा, पुणे",
            },
            anniversary: {
                English: "Birth Anniversary",
                मराठी: "जयंती",
            },
            date: {
                English: "11th April",
                मराठी: "११ एप्रिल",
            },
        },
        {
            id: 8,
            name: {
                English: "Swatyantravir Savarkarwada, Bhagur, Dist. Nashik",
                मराठी: "स्वा.सावरकरवाडा, भगूर, जि.नाशिक",
            },
            anniversary: {
                English: "Birth Anniversary",
                मराठी: "जयंती",
            },
            date: {
                English: "28th May",
                मराठी: "२८ मे",
            },
        },
        {
            id: 9,
            name: {
                English: "R.Chh.Shahu Maharaj Birth Place, Kolhapur",
                मराठी: "रा.छ.शाहू महाराज जन्मस्थळ, कोल्हापूर",
            },
            anniversary: {
                English: "Birth Anniversary",
                मराठी: "जयंती",
            },
            date: {
                English: "26th June",
                मराठी: "२६ जुन",
            },
        },
        {
            id: 10,
            name: {
                English: "Lokmanya Tilak Birthplace, Ratnagiri",
                मराठी: "लोकमान्य टिळक जन्मस्थान, रत्नागिरी",
            },
            anniversary: {
                English: "Death Anniversary",
                मराठी: "पुण्यतिथी",
            },
            date: {
                English: "1st August",
                मराठी: "१ ऑगस्ट",
            },
        },
        {
            id: 11,
            name: {
                English: "Hutatma Rajguru Birth Place, Rajguru Nagar, Ta. Khed, Dist. Pune",
                मराठी: "हुतात्मा राजगुरू जन्मस्थान, राजगुरू नगर, ता. खेड, जि. पुणे",
            },
            anniversary: {
                English: "Birth Anniversary",
                मराठी: "जयंती",
            },
            date: {
                English: "24th August",
                मराठी: "२४ ऑगस्ट",
            },
        },
        {
            id: 12,
            name: {
                English: "Mahatma Phule Wada, Pune",
                मराठी: "महात्मा फुले वाडा, पुणे",
            },
            anniversary: {
                English: "Death Anniversary",
                मराठी: "पुण्यतिथी",
            },
            date: {
                English: "28th November",
                मराठी: "२८ नोव्हेंबर",
            },
        },
        {
            id: 13,
            name: {
                English: "World Heritage Day",
                मराठी: "जागतिक वारसा दिन",
            },
            anniversary: {
                English: "-",
                मराठी: "-",
            },
            date: {
                English: "18th April",
                मराठी: "१८ एप्रिल",
            },
        },
        {
            id: 14,
            name: {
                English: "International Museum Day",
                मराठी: "आंतरराष्ट्रीय संग्रहालय दिवस",
            },
            anniversary: {
                English: "-",
                मराठी: "-",
            },
            date: {
                English: "18th May",
                मराठी: "१८ मे",
            },
        },
        {
            id: 15,
            name: {
                English: "World Heritage Week",
                मराठी: "जागतिक वारसा सप्ताह",
            },
            anniversary: {
                English: "-",
                मराठी: "-",
            },
            date: {
                English: "19th November – 25th November",
                मराठी: "१९ नोव्हेंबर- २५ नोव्हेंबर",
            },
        },
    ];

    return (
        <div className='px-8 py-12'>
            {/* Title */}
            < div className="text-center mb-8" >
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}
                        /{" "}
                    </span>
                    {t.breadcrumb.page}
                </p>
            </div >

            {/* Table Section */}
                <div
                    className="max-w-6xl mx-auto bg-[#EFEDE0] rounded-xl overflow-x-auto"
                    style={{ border: "2px solid #F8D6BF" }}
                >
                    <table className="min-w-full bg-[#EFEDE0] text-center text-black text-sm sm:text-base">
                        <thead className='font-bold tracking-wide'
                            style={{
                                textShadow: '0.3px 0.3px 0 black',
                            }}>
                            <tr>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.srNo[selectedLang]}
                                </th>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.name[selectedLang]}
                                </th>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.anniversary[selectedLang]}
                                </th>
                                <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.date[selectedLang]}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc, index) => (
                                <tr key={doc.id}
                                    className="hover:bg-[#F6F6EC]">
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                                    </td>
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {doc.name[selectedLang]}
                                    </td>
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {doc.anniversary[selectedLang]}
                                    </td>
                                    <td className="py-3 px-4 border-t-2 " style={{ borderColor: '#F8D6BF' }}>
                                        {doc.date[selectedLang]}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
        </div>
    )
}

export default Events
